<template>
  <div>

    <div class="mb-8">
      <h3 class="mb-2 text-sm">Additional products to enhance your property:</h3>
      <p v-if="packAddons.length === 0" class="text-grey-dark italic">This pack has no available add-ons.</p>
      <table class="w-full">
        <tbody>
          <tr v-if="focalAgentDronePhotoPackItem && focalAgentDroneVideoPackItem">
            <td class="pb-3">
              <input type="checkbox" id="fadrone" v-model="focalAgentDroneCheckbox" />
              <label for="fadrone" class="mr-12">Drone Photography & Video</label>
            </td>
            <td class="pb-3 text-right">
              <span v-if="focalAgentDronePhotoPackItem.included_in_pack" class="italic text-grey-darker">Included in this pack</span>
              <span v-else>{{ parseFloat(focalAgentDronePhotoPackItem.pivot.price) | gbp }} <small class="text-grey">+VAT</small></span>
            </td>
          </tr>

          <tr v-for="(addon, i) in packAddons" :key="i">
            <td class="pb-3">
              <input type="checkbox" :id="`addon${i}`" v-model="orderAddons" :value="addon.id" />
              <label :for="`addon${i}`" class="mr-12">{{ addon.name }}</label>
            </td>
            <td class="pb-3 text-right">
              <span v-if="addon.included_in_pack" class="italic text-grey-darker">Included in this pack</span>
              <span v-else-if="addon.internal_type_id === 6 && addon.options.length">
                <select v-if="presentersOrderItem" class="border hover:border-grey-darker p-3" v-model="presentersOrderItem.data.id">
                  <option v-for="(option, i) in addon.options" :key="i" :value="i">
                    {{ option.copies }} {{ option.copies === 1 ? 'Copy' : 'Copies' }} - {{ parseFloat(option.price) | gbp }} +VAT
                  </option>
                </select>
                <span v-else>From {{ parseFloat(addon.options[0].price) | gbp }} <small class="text-grey">+VAT</small></span>
              </span>
              <span v-else-if="addon.internal_type_id === 17 && addon.options.length">
                <select v-if="dronePhotoOrderItem" class="border hover:border-grey-darker p-3" v-model="dronePhotoOrderItem.data.id">
                  <option v-for="(option, i) in addon.options" :key="i" :value="i">
                    {{ option.name }} - {{ parseFloat(option.price) | gbp }} +VAT
                  </option>
                </select>
                <span v-else>From {{ parseFloat(addon.options[0].price) | gbp }} <small class="text-grey">+VAT</small></span>
              </span>
              <span v-else-if="addon.internal_type_id === 18 && addon.options.length">
                <select v-if="droneVideoOrderItem" class="border hover:border-grey-darker p-3" v-model="droneVideoOrderItem.data.id">
                  <option v-for="(option, i) in addon.options" :key="i" :value="i">
                    {{ option.name }} - {{ parseFloat(option.price) | gbp }} +VAT
                  </option>
                </select>
                <span v-else>From {{ parseFloat(addon.options[0].price) | gbp }} <small class="text-grey">+VAT</small></span>
              </span>
              <span v-else>{{ parseFloat(addon.pivot.price) | gbp }} <small class="text-grey">+VAT</small></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { filter, find } from 'lodash'

export default {
  props: ['value', 'pack'],
  data () {
    return {
      order: this.value
    }
  },
  computed: {
    packAddons () {
      // Remove Focal Agent drone items from this list. They need to be ordered together as 1 option, but treated as 2.
      return filter(this.pack.items, (item) => (item.is_addon || item.internal_type_id === 5) && ![
        this.focalAgentDronePhotoPackItem ? this.focalAgentDronePhotoPackItem.id : null,
        this.focalAgentDroneVideoPackItem ? this.focalAgentDroneVideoPackItem.id : null
      ].includes(item.id))
    },
    orderAddons: {
      get () {
        let output = []
        for (let i = 0; i < this.packAddons.length; i++) {
          if (find(this.order.items, (item) => item.marketing_pack_item_id === this.packAddons[i].id)) {
            output.push(this.packAddons[i].id)
          }
        }

        return output
      },
      set (addons) {
        for (let i = 0; i < this.packAddons.length; i++) {
          const existing = find(this.order.items, (item) => item.marketing_pack_item_id === this.packAddons[i].id)
          if (existing && !addons.includes(this.packAddons[i].id)) {
            this.order.items.splice(this.order.items.indexOf(existing), 1)
          }

          if (!existing && addons.includes(this.packAddons[i].id)) {
            if ([6, 17, 18].includes(this.packAddons[i].internal_type_id)) {
              this.order.items.push({
                marketing_pack_item_id: this.packAddons[i].id,
                delivery_address_id: null,
                data: {
                  id: 0
                }
              })
            } else {
              this.order.items.push({
                marketing_pack_item_id: this.packAddons[i].id,
                delivery_address_id: null
              })
            }
          }
        }
      }
    },
    presentersPackItem () {
      return find(this.pack.items, (item) => item.internal_type_id === 6)
    },
    presentersOrderItem () {
      return find(this.order.items, (item) => item.marketing_pack_item_id === this.presentersPackItem.id)
    },
    dronePhotoPackItem () {
      return find(this.pack.items, (item) => item.internal_type_id === 17)
    },
    dronePhotoOrderItem () {
      return find(this.order.items, (item) => item.marketing_pack_item_id === this.dronePhotoPackItem.id)
    },
    droneVideoPackItem () {
      return find(this.pack.items, (item) => item.internal_type_id === 18)
    },
    droneVideoOrderItem () {
      return find(this.order.items, (item) => item.marketing_pack_item_id === this.droneVideoPackItem.id)
    },

    // Focal Agent
    focalAgentDronePhotoPackItem () {
      return find(this.pack.items, (item) => item.internal_type_id === 17 && item.fulfillment_by === 7)
    },
    focalAgentDronePhotoOrderItem () {
      return find(this.order.items, (item) => item.marketing_pack_item_id === this.focalAgentDronePhotoPackItem.id)
    },
    focalAgentDroneVideoPackItem () {
      return find(this.pack.items, (item) => item.internal_type_id === 18 && item.fulfillment_by === 7)
    },
    focalAgentDroneVideoOrderItem () {
      return find(this.order.items, (item) => item.marketing_pack_item_id === this.focalAgentDroneVideoPackItem.id)
    },
    focalAgentDroneCheckbox: {
      get () {
        return this.focalAgentDronePhotoOrderItem && this.focalAgentDroneVideoOrderItem
      },
      set (add) {
        if (add) {
          this.order.items.push({
            marketing_pack_item_id: this.focalAgentDronePhotoPackItem.id,
            delivery_address_id: null,
            data: null
          })
          this.order.items.push({
            marketing_pack_item_id: this.focalAgentDroneVideoPackItem.id,
            delivery_address_id: null,
            data: null
          })
          return
        }

        this.order.items.splice(this.order.items.indexOf(this.focalAgentDronePhotoOrderItem), 1)
        this.order.items.splice(this.order.items.indexOf(this.focalAgentDroneVideoOrderItem), 1)
      }
    }
  },
  watch: {
    order: {
      handler () {
        this.$emit('input', this.order)
      },
      deep: true
    }
  }
}
</script>
